import {Component} from "@angular/core";
import {App, ModalController, NavController, NavParams} from "ionic-angular";
import {CartService} from "../../app/services/cart.service";
import {Cart} from "../../app/classes/cart";
import {CheckoutPage} from "../checkout/checkout";
import {RegisterPage} from "../register/register";
import {UserService} from "../../app/services/user.service";
import {Product} from "../../app/classes/product";
import {ProductOptionPage} from "../product-option/product-option";
import {MenuPage} from "../menu/menu";
import {API} from "../../app/services/api.service";
import {Customer} from "../../app/classes/customer";
import {TrackPage} from "../trackpage/TrackPage";
import {AnalyticsService} from "../../app/services/analytics.service";
import {Http} from "@angular/http";
import { Dialog } from '@capacitor/dialog';
import {ProductSpecialPage} from "../product-special/product-special";
/*
 Generated class for the Cart page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-cart',
  templateUrl: 'cart.html',
  providers: [
    CartService, UserService]
})
export class CartPage extends TrackPage {
  public cart: Cart;
  public customer: Customer;
  public errorMessage: Error;
  public openingTimeInterval: any;
  public isOpen: boolean = true;

  constructor(private analytics : AnalyticsService, private cartService: CartService,
              public userService: UserService,
              public navCtrl: NavController,
              public api: API,
              public http: Http,
              public modalCtrl: ModalController, public navParams: NavParams, public appCtrl: App) {
    super();
    this.cart = this.cartService.getCart();

  }


  ionViewWillEnter() {
    this.customer = Customer.cachedOrCreate(this.http) as Customer;
    this.analytics.trackView("Cart");
    this.openingTimeInterval = setInterval(() => {
      this.checkOpeningTimes();
    }, 10000);
    this.checkOpeningTimes();
  }

  ionViewWillLeave() {
    this.customer = Customer.cachedOrCreate(this.http) as Customer;
    clearInterval(this.openingTimeInterval);
  }

  checkOpeningTimes() {
    this.api.isOpen().subscribe(
      result => this.isOpen = result.opened,
      error => () => {
      }
    );
  }

  gotoMenus() {
    this.appCtrl.getRootNav().push(MenuPage);
  }

  gotoCheckout() {
    this.userService.get().then((user) => {
      if (user.account.verified) {
        this.navCtrl.push(CheckoutPage);
      } else {
        this.navCtrl.push(RegisterPage)
      }
    }).catch(() => {
      Dialog.alert({
       message: 'Fehler beim Laden des Benutzeraccounts. Bitte starte unsere App einmalig neu damit deine Änderungen übernommen werden.',
       title: null
      })
        .then(() => console.log('Dialog dismissed'))
        .catch(e => console.log('Error displaying dialog', e));
    });
  }

  changeProduct(originalProduct: Product) {
    const modal = this.modalCtrl.create(ProductOptionPage, {product: originalProduct});
    modal.onDidDismiss((newProduct) => {
      if (newProduct) {

      }
    });
    modal.present();
  }

  changeProductSpecial(originalProduct: Product) {
    const modal = this.modalCtrl.create(ProductSpecialPage, {product: originalProduct});
    modal.onDidDismiss((newProduct) => {
      if (newProduct) {
          this.cart.replaceProduct(originalProduct,newProduct);
      }
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/cart/cart.ts